export const glassesZipFileName = "Glasses_2.5D_texture_api"

export const effectZipPath = `/assets/${glassesZipFileName}.zip`

export enum TextureFileNames {
  MAT_LEFT_BASE_COLOR = "mat_left_BaseColor.png",
  MAT_FRONT_BASE_COLOR = "mat_front_BaseColor.png",
  MAT_RIGHT_BASE_COLOR = "mat_right_BaseColor.png",
  RENDERING_OPTIONS = "renderingOptions.json",
  CONFIG_JSON = "config.json",
}

export enum TexturePaths {
  MAT_LEFT_BASE_COLOR = `${glassesZipFileName}/images/${TextureFileNames.MAT_LEFT_BASE_COLOR}`,
  MAT_FRONT_BASE_COLOR = `${glassesZipFileName}/images/${TextureFileNames.MAT_FRONT_BASE_COLOR}`,
  MAT_RIGHT_BASE_COLOR = `${glassesZipFileName}/images/${TextureFileNames.MAT_RIGHT_BASE_COLOR}`,
  RENDERING_OPTIONS = `${glassesZipFileName}/${TextureFileNames.RENDERING_OPTIONS}`,
  CONFIG_JSON = `${glassesZipFileName}/${TextureFileNames.CONFIG_JSON}`,
}
